import { render } from "./OrderPaymentDetailsModal.vue?vue&type=template&id=01a67e63"
import script from "./OrderPaymentDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderPaymentDetailsModal.vue?vue&type=script&lang=js"

import "./OrderPaymentDetailsModal.vue?vue&type=style&index=0&id=01a67e63&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__